<template>
  <div v-if="useMasterSlave" class="text-center">
      <v-menu 
      bottom
          offset-y
          rounded="b-xl t-0"
          :disabled="disabled"
          content-class="mt-1 menuShadow"
          outlined
        >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar size="40" :color="avatarColor" :class="avatarClass" @click="onAvatarClick" v-bind="attrs"
            v-on="on">
              <v-img
                  src="/img/icons/team-leader.png"
                  :alt="(isTeamLeader)?$t('app_teamname_leader'):$t('app_team_master_request_change')"
              />
          </v-avatar>
        </template>
        <!-- Is teamleader -->
        <span v-if="isOnline">
          <span v-if="isTeamLeader" >
            <v-list v-if="teamMembers && teamMembers.length>1" class="">
              <v-list-item
                v-for="(item, index) in teamMembers"
                :key="index"
                @click="notifyTeamleaderChanged(item.id)"
                :class="{'d-none':(userId==item.id)}"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </span>
          <!-- is slave -->
          <span v-else>
            <v-list class="">
              <v-list-item @click="requestTeamleaderChange()">
                <v-list-item-title>{{$t('app_team_master_request_change')}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </span>
        </span>
      </v-menu>
  </div>
</template>

<script>
    import { EventBusNotification } from '@/components/EventBusNotification.js'
    import {teamMixin} from '@/utils/team-mixin'
    import {websocketMixin} from '@/utils/websocket-mixin'
           
    export default {
        mixins: [EventBusNotification,teamMixin,websocketMixin],
        props:{
            isMobile:{
                type:Boolean,
                default:false
            },
            isPad:{
                type:Boolean,
                default:false
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        computed: {
          avatarColor(){
            return (this.isOnline)?((this.isTeamLeader)?'yellow':'lightgrey'):'red';
          },
          avatarClass(){
            return (this.isOnline)?(this.isTeamLeader?'avatar-teamleader':''):'avatar-offline';
          }
        },
        data() {
            return {
            }
        },
        methods: {
          onAvatarClick(){
            if(this.isOffline){
              EventBusNotification.$emit('notify',this.$t('error_websocket_offline'));
              /*
              EventBusNotification.$emit('notify',this.$t('error_websocket_offline'),this.$t('reload'),null,5,()=>{
                location.reload();
              });*/
            }
          }
        },
    }
</script>

<style scoped>
.menuShadow{
  -webkit-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
  -moz-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
}

.avatar-teamleader{
	box-shadow: 0 0 0 0 rgb(236, 207, 109);
	transform: scale(1);
	animation: pulse-yellow 2s infinite;
}

@keyframes pulse-yellow {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(236, 207, 109, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(236, 207, 109, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(236, 207, 109, 0);
	}
}

.avatar-offline{
	box-shadow: 0 0 0 0 rgb(248, 80, 58);
	transform: scale(1);
	animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(248, 80, 58, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(248, 80, 58, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(248, 80, 58, 0);
	}
}
</style>